import { render, staticRenderFns } from "./ModalAdicionarToken.vue?vue&type=template&id=01a4fd5f"
import script from "./ModalAdicionarToken.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports